var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.25C9.329 8.25 6.75 10.83 6.75 14C6.75 17.17 9.329 19.75 12.5 19.75C15.671 19.75 18.25 17.17 18.25 14C18.25 10.83 15.671 8.25 12.5 8.25ZM14.455 14.75H12.5C12.086 14.75 11.75 14.414 11.75 14V11.965C11.75 11.551 12.086 11.215 12.5 11.215C12.914 11.215 13.25 11.551 13.25 11.965V13.25H14.455C14.869 13.25 15.205 13.586 15.205 14C15.205 14.414 14.869 14.75 14.455 14.75ZM13.5 0.25H3.5C1.98 0.25 0.75 1.48 0.75 3V16C0.75 17.52 1.98 18.75 3.5 18.75H7.04C5.92 17.48 5.25 15.82 5.25 14C5.25 10 8.5 6.75 12.5 6.75C13.88 6.75 15.16 7.13 16.25 7.81V3C16.25 1.48 15.02 0.25 13.5 0.25ZM5.5 10.75H4.5C4.09 10.75 3.75 10.41 3.75 10C3.75 9.59 4.09 9.25 4.5 9.25H5.5C5.91 9.25 6.25 9.59 6.25 10C6.25 10.41 5.91 10.75 5.5 10.75ZM8.5 7.75H4.5C4.09 7.75 3.75 7.41 3.75 7C3.75 6.59 4.09 6.25 4.5 6.25H8.5C8.91 6.25 9.25 6.59 9.25 7C9.25 7.41 8.91 7.75 8.5 7.75ZM12.5 4.75H4.5C4.09 4.75 3.75 4.41 3.75 4C3.75 3.59 4.09 3.25 4.5 3.25H12.5C12.91 3.25 13.25 3.59 13.25 4C13.25 4.41 12.91 4.75 12.5 4.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHistory);
export default __webpack_public_path__ + "static/media/ico-history.30e793cb854063c2b6552110b14cc9db.svg";
export { ForwardRef as ReactComponent };